// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 15.546 15.546\"> <path d=M26.3,14.81V25.046H21.178V19.659h-4.31v5.387H11.75V14.81l7.273-4.31Z transform=\"translate(-11.25 -10)\" fill=none stroke=currentColor stroke-linecap=round stroke-linejoin=round stroke-width=1 /> </svg> ";
// Exports
module.exports = code;